/**
 * 교회학교 게시판 페이지
 */

import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { MainLayout, BoardList } from '../../../../shared/components';
import { Button } from '../../../../shared/components/UI/Button';
import { theme } from '../../../../shared/styles/theme';
import { mediaQueries } from '../../../../shared/constants/breakpoints';
import { useBoard } from '../../../../shared/hooks';

const PageContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: ${theme.spacing.xxxl} ${theme.spacing.lg};

  ${mediaQueries.maxMobile} {
    padding: ${theme.spacing.xl} ${theme.spacing.md};
  }
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: ${theme.spacing.xxxl};
`;

const PageTitle = styled.h1`
  font-size: ${theme.fontSizes.xxxl};
  font-weight: 700;
  color: ${theme.colors.primary};
  margin-bottom: ${theme.spacing.md};
  font-family: ${theme.fonts.heading};

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.xxl};
  }
`;

const PageSubtitle = styled.p`
  font-size: ${theme.fontSizes.lg};
  color: ${theme.colors.textLight};

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.md};
  }
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${theme.spacing.lg};
  margin-top: ${theme.spacing.xxxl};
`;

const PageInfo = styled.span`
  font-weight: 600;
  color: ${theme.colors.text};
  min-width: 80px;
  text-align: center;
`;

export const SundaySchoolBoard: React.FC = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);

  // React Query로 게시글 목록 조회 (자동 캐싱)
  const { data, isLoading } = useBoard('sunday-school', { page, limit: 9 });

  const posts = data?.data || [];
  const totalPages = data?.pagination.totalPages || 1;

  const handlePostClick = (postId: number) => {
    navigate(`/sunday-school/board/${postId}`);
  };

  return (
    <MainLayout>
      <PageContainer>
        <PageHeader>
          <PageTitle>교회학교 게시판</PageTitle>
          <PageSubtitle>교회학교의 다양한 활동과 소식을 전합니다</PageSubtitle>
        </PageHeader>

        <BoardList posts={posts} onPostClick={handlePostClick} />

        {totalPages > 1 && (
          <Pagination>
            <Button onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1}>
              이전
            </Button>
            <PageInfo>
              {page} / {totalPages}
            </PageInfo>
            <Button
              onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
              disabled={page === totalPages}
            >
              다음
            </Button>
          </Pagination>
        )}
      </PageContainer>
    </MainLayout>
  );
};
